export default __webpack_public_path__ + "static/media/50t.b365054e.jpg";